// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","744":"27aff130","801":"6ba399e6"}[chunkId] + ".chunk.js";
};